import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
import { bannerTheme } from "./bannerTheme";
var getColor = function getColor(_ref) {
  var type = _ref.type,
    themeMode = _ref.themeMode;
  return bannerTheme.fontColor[type](themeMode);
};
var getBackgroundColor = function getBackgroundColor(_ref2) {
  var type = _ref2.type,
    themeMode = _ref2.themeMode;
  return bannerTheme.backgroundColor[type](themeMode);
};
export var BannerStyled = withFocusToggleClassName(styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-height: 48px;\n    box-sizing: border-box;\n    display: flex;\n    align-items: flex-start;\n\n    color: ", ";\n    background-color: ", ";\n\n    font-weight: 500;\n    font-size: 14px;\n\n    ", ";\n"])), getColor, getBackgroundColor, function (_ref3) {
  var themeMode = _ref3.themeMode;
  return createFocusRingStyles({
    theme: themeMode,
    componentRadius: "0",
    gap: 1,
    componentBorderWidth: 1
  });
}));
BannerStyled.displayName = "BannerStyled";
//# sourceMappingURL=BannerStyled.js.map